<template>
  <div class="home">
    <p>HOME RAWR</p>
    <img alt="Vue logo" src="../assets/logo.png" />
    
    
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  components: {
    // HelloWorld
  }
};
</script>
